import React from 'react'
import { Header } from '.'
import { Exel } from 'assets'
import { Divider, IconButton, SvgIcon } from '@mui/material'
import { ReactComponent as GoIcon } from 'assets/icons/Go.svg';
import { ReactComponent as UploadFileIcon } from 'assets/icons/UploadFile.svg';
import { ReactComponent as AllocationIcon } from 'assets/icons/Allocation.svg';
import { ReactComponent as AddDidabledIcon } from 'assets/icons/AddDidabled.svg';
import { ReactComponent as TesttakersIcon } from 'assets/icons/Testtakers.svg';
import { ButtonStyles, StudentStyles } from './Style';
import { Add, CheckBox, Done, DragIndicator, Edit } from '@mui/icons-material';
import { Button } from 'components/Form';
import { Img, LightButton } from 'styles/GlobalStyle';
import { useNavigate } from 'react-router-dom';
import { app } from 'router/routes';
import { thirdly4 } from 'styles/theme';

const Students = () => {
    const navigate = useNavigate()

    const title = "הוספת תלמידים והקצאת אבחונים"
    const subTitle = "ככה זה עובד"

    return (
        <StudentStyles>
            <Header title={title} subTitle={subTitle} />
            <div className='title'>{"רשימת התלמידים"}</div>
            <div className='content'>
                <div className='general-item'>
                    <div className='section'>
                        <div className='item-button'>
                            <ButtonStyles variant='contained' color="dark">
                                <SvgIcon sx={{ fontSize: 14 }} component={TesttakersIcon} inheritViewBox />
                                {"תלמידים"}
                            </ButtonStyles>
                        </div>
                        <div className='item-card'>
                            <div className='student-table-label'>
                                {"עריכת פרטי התלמיד"}
                            </div>
                            <div>
                                {[...Array(2)].map((_, index) =>
                                    <React.Fragment>
                                        <div className='table-row'>
                                            <div className='table-col blurred'>12</div>
                                            <div className='table-col blurred'>אור כספי</div>
                                            <div className='table-col blurred'>כיתה ד</div>
                                            <div className='table-col blurred'>עזרת תורה</div>
                                            <div className='table-col blurred'>1</div>
                                            <div className='table-col blurred'>
                                                <SvgIcon component={AddDidabledIcon} inheritViewBox />
                                            </div>
                                            <div className='table-col edit-col'>
                                                <Edit />
                                                {!index ||
                                                    <div className='wrap-circle-border'>
                                                        <div className='circle-border edit-circle-border' />
                                                    </div>}
                                            </div>
                                        </div>
                                        <Divider sx={{ borderColor: thirdly4 }} />
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                        <div className='student-actions'>
                            <div className='title'>{"פעולות"}</div>
                            <div className='assessments-actions'>
                                <div className='item-button'>
                                    <LightButton size="small" label={"הוספת תלמיד"} icon={<SvgIcon sx={{ fontSize: 14 }} component={AllocationIcon} inheritViewBox />} />
                                </div>
                                <div className='add-testtaker'>
                                    <div className='item-card'>
                                        <div className='testtakers' >
                                            <div className='item-card-header'>
                                                {"פרטי תלמיד חדש יחיד"}
                                                <IconButton onClick={() => navigate(app.testTakers)}>
                                                    <SvgIcon component={GoIcon} inheritViewBox />
                                                </IconButton>
                                            </div>
                                            <div className='item-card-light new-testtaker-popup'>
                                                <div className='new-testtaker-rows'>
                                                    <div className='new-testtaker-row'>
                                                        <div className='input-field'>
                                                            <div className='blurred'>שם פרטי</div>
                                                        </div>
                                                        <div className='input-field grow1'>
                                                            <div className='blurred'>שם פרטי</div>
                                                        </div>
                                                    </div>
                                                    <div className='full-row-item'>
                                                        <div className='input-field'>
                                                            <div className='blurred'>שם משפחה</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='new-testtaker-actions'>
                                                    <Button width="70px" color="thirdly2" label="" size="small" />
                                                    <Button width="90px" color="thirdly" label="" size="small" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='item-card exel-students'>
                                        <div>
                                            <div className='testtakers' >
                                                <div className='item-card-header'>
                                                    {"רשימת תלמידים חדשים"}
                                                    <IconButton onClick={() => navigate(app.testTakers)}>
                                                        <SvgIcon component={GoIcon} inheritViewBox />
                                                    </IconButton>
                                                </div>
                                                <div>
                                                    <div className='item-card-light testtaker-export-list'>
                                                        <div className='testtaker-list'>
                                                            <div className='row'>
                                                                {[...Array(3)].map((item) =>
                                                                    <div className='row-item small-row-item' />
                                                                )}
                                                            </div>
                                                            <div className='row'>
                                                                {[...Array(3)].map((item) =>
                                                                    <div className='row-item small-row-item' />
                                                                )}
                                                            </div>
                                                            <div className='row'>
                                                                {[...Array(3)].map((item) =>
                                                                    <div className='row-item small-row-item' />
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className='export-exel'>
                                                            <Img src={Exel} />
                                                            <SvgIcon component={UploadFileIcon} inheritViewBox />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='assessments-actions'>
                                <div className='item-button'>
                                    <LightButton size="small" label={"הקצאת אבחונים"} icon={<SvgIcon sx={{ fontSize: 14 }} component={AllocationIcon} inheritViewBox />} />
                                </div>
                                <div className='item-card'>
                                    <div className='item-card'>
                                        <div className='item-card-header'>
                                            {"הקצאת אבחון לתלמיד מתוך רשימת האבחונים"}
                                            <IconButton onClick={() => navigate(app.testTakers)}>
                                                <SvgIcon component={GoIcon} inheritViewBox />
                                            </IconButton>
                                        </div>
                                        <div className='item-card-header'>
                                            {"בחירת תלמיד וכניסה להקצאת אבחונים"}
                                            <div className='assessment-allocation-btn'>
                                                <LightButton size="small" label="הקצאת אבחונים" />
                                            </div>
                                        </div>
                                        <div className='table-row'>
                                            <div className='table-col'>
                                                <CheckBox color="thirdly" defaultChecked />
                                                <div className='wrap-circle-border'>
                                                    <div className='circle-border checkbox-col' />
                                                </div>
                                            </div>
                                            <div className='table-col blurred'>תמר</div>
                                            <div className='table-col blurred'>תמר דינר</div>
                                            <div className='table-col blurred'>עזרת תורה</div>
                                            <div className='table-col blurred'>בני ברק</div>
                                            <div className='table-col blurred'>4</div>
                                            <div className='table-col blurred'>
                                                <SvgIcon component={AddDidabledIcon} inheritViewBox />
                                            </div>
                                            <div className='table-col blurred'>
                                                <Edit />
                                            </div>
                                        </div>
                                        <div>{"בחירת האבחונים הרצויים"}</div>
                                        <div className='wrap-select-assessments'>
                                            <div className='select-assessments'>
                                                {[...Array(3)].map((_, index) =>
                                                    <div className='select-assessment'>
                                                        <div className='c-sp-between'>
                                                            <div className='assessment-chip assessment-type blurred'>קטע סיפורי קמץ פתח</div>
                                                            <div className='assessment-chip assessment-grade blurred'>d א</div>
                                                        </div>
                                                        <div className='assessment-name blurred'>שיום מילים</div>
                                                        <div className='c-sp-between'>
                                                            <div className='assessment-chip assessment-source blurred'>Go Read</div>
                                                            <div className='assessment-chip word-count blurred'>13 מילים</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className='assessment-set'>
                                                <div className='assessment-set-items'>
                                                    {[...Array(2)].map((item) =>
                                                        <div className='allocation-row'>
                                                            <div className='allocation-row-selected'>
                                                                <DragIndicator fontSize='small' color="white" />
                                                            </div>
                                                            <div className='blurred'>חוטב העצים</div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className='allocation-btn'>
                                                    <Button fullWidth size="small" color="secondary" label="הקצאה" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </StudentStyles >
    )
}

export default Students